import { Form, Input, Spin, Typography } from 'antd';
import { Rule } from 'antd/es/form';

import InfoTooltip from 'components/info/info';

interface FormItemInputProps {
	name: string | string[] | number[] | any;
	type: 'email' | 'number' | 'tel' | 'text';
	label?: string;
	rules?: Rule[];
	fullWidth?: boolean;
	disabled?: boolean;
	addonAfter?: React.ReactNode;
	simple?: boolean;
	description?: string;
	onChange?: (value: string) => void;
	maxLength?: number;
	min?: number;
	max?: number;
	loading?: boolean;
	noAutoComplete?: boolean;
}

function FormElement({
	noAutoComplete,
	name,
	label,
	rules,
	type,
	fullWidth,
	addonAfter,
	simple,
	description,
	disabled,
	maxLength,
	min,
	max,
	loading = false,

	onChange,
}: FormItemInputProps) {
	return (
		<>
			{label && (
				<Typography.Text style={{ marginBottom: 5, display: 'block', fontSize: 15, textAlign: 'start' }}>
					{label}
					{description && <InfoTooltip title={description} style={{ marginTop: -2 }} />}
				</Typography.Text>
			)}
			<Spin spinning={loading}>
				<Form.Item name={name} rules={rules} style={{ maxWidth: fullWidth ? 'unset' : 'var(--inputWidth)' }}>
					<Input
						className={simple ? 'simple' : ''}
						disabled={disabled}
						type={type}
						min={min}
						max={max}
						addonAfter={addonAfter ? addonAfter : null}
						onKeyDown={(e) => {
							if (
								maxLength &&
								e.key !== 'Backspace' &&
								e.key !== 'Delete' &&
								e.key !== 'Tab' &&
								e.key !== 'ArrowLeft' &&
								e.key !== 'ArrowRight' &&
								(e.target as HTMLInputElement).value.length >= maxLength
							) {
								e.preventDefault();
							}
						}}
						autoComplete={noAutoComplete ? 'new-password' : 'on'}
						onChange={(e) => onChange && onChange(e.target.value)}
					/>
				</Form.Item>
			</Spin>
		</>
	);
}

export default FormElement;
